
import { useEffect } from "react";
import UserProfile from "@/components/UserProfile";
import { useScrollToTop } from "@/hooks/useScrollToTop";

const Profile = () => {
  // Add scroll to top behavior
  useScrollToTop();
  
  return (
    <div className="min-h-screen pt-32 pb-16">
      <div className="container mx-auto px-4">
        <div className="max-w-md mx-auto">
          <h1 className="text-3xl font-playfair font-bold text-heaven-gold mb-8 text-center">
            My Profile
          </h1>
          <UserProfile />
        </div>
      </div>
    </div>
  );
};

export default Profile;
